import styles from "../../styles/playerEcosystem.module.css";

/**
 * Cross-sport summary for Overall profile.
 * @param {{ summary: {
 *   sportsPlayed?: number,
 *   favouriteSport?: { label: string, matches: number } | null,
 *   sports?: Array<{ sportId: string, label: string, matches: number, wins: number, losses: number }>,
 *   recentSportActivity?: Array<{ label: string, lastPlayedLabel?: string, matches: number }>,
 * } }} props
 */
export default function CrossSportSummary({ summary }) {
  if (!summary?.sports?.length) return null;
  return (
    <div className={styles.crossSport} aria-label="Cross-sport summary">
      <div className={styles.crossSportHero}>
        <div>
          <p className={styles.statLabel}>Sports played</p>
          <p className={styles.statValue}>{summary.sportsPlayed ?? summary.sports.length}</p>
        </div>
        {summary.favouriteSport ? (
          <div>
            <p className={styles.statLabel}>Favourite</p>
            <p className={styles.statValue} style={{ fontSize: "1.05rem" }}>
              {summary.favouriteSport.label}
            </p>
            <p className={styles.muted}>{summary.favouriteSport.matches} matches</p>
          </div>
        ) : null}
      </div>
      <ul className={styles.crossSportList}>
        {summary.sports.map((s) => {
          const pct = s.matches ? Math.round((s.wins / s.matches) * 100) : 0;
          return (
            <li key={s.sportId}>
              <div className={styles.crossSportRow}>
                <strong>{s.label}</strong>
                <span className={styles.muted}>
                  {s.wins}–{s.losses} · {pct}%
                </span>
              </div>
              <div className={styles.crossBarTrack} aria-hidden>
                <div
                  className={styles.crossBarFill}
                  style={{ width: `${Math.min(100, Math.max(8, pct))}%` }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
